import { merge } from 'utils/immutable'
import * as actions from 'actions/feature/featureMetadata'
import { initialFeatureMetaData } from 'reducers/feature'

export default {
  [actions.SET_FEATURE_FIELD]: updateFeatureField,
  [actions.updateXmcModuleName]: updateXmcModuleName,
  [actions.resetCurrentFeatureMetadata]: resetCurrentFeatureMetadata,
}

function updateXmcModuleName(state, { featureId, moduleName }) {
  return state.setIn(
    ['currentFeature', 'feature', featureId, 'moduleName'],
    moduleName
  )
}

function updateFeatureField(state, { featureId, paramName, value }) {
  // TODO: 'feature' should be pl: 'features' if this is an id-keyed collection
  return state.setIn(['currentFeature', 'feature', featureId, paramName], value)
}

function resetCurrentFeatureMetadata(state, { featureId }) {
  return state.updateIn(
    ['currentFeature', 'feature', featureId],
    merge(initialFeatureMetaData)
  )
}
